/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import Limiter from "../../../../components/atoms/Limiter";
import ExpandLink from "../../../../components/atoms/Limiter/ExpandLink";
import TableSorter from "../../../../components/atoms/TableSorter";
import GWASTable from "./GWASTable";
import { sortNumDate } from "../../../../common/helpers/helpers";

const sortByDate = (a, b) => sortNumDate(a.date, b.date);

const renderTable = (props) => {
  return <GWASTable {...props} />;
};

const renderLimiter = (props) => {
  return (
    <div className="varsome-inner-container">
      <Limiter
        {...props}
        ExpandLink={(p) => (
          <div className="tw-p-2">
            <ExpandLink {...p} />
          </div>
        )}
        items={props.sortedItems}
        limit={10}
        renderContent={renderTable}
      />
    </div>
  );
};

class GWASContent extends React.PureComponent {
  render() {
    const { gwasList } = this.props;
    return (
      <TableSorter
        {...this.props}
        items={gwasList}
        defaultSortedField="date"
        defaultComparator={sortByDate}
        defaultIsAsc={false}
        renderContent={renderLimiter}
      />
    );
  }
}

GWASContent.propTypes = {
  labels: PropTypes.shape({
    pubMedReferences: PropTypes.string,
    date: PropTypes.string,
    pValue: PropTypes.string,
    diseaseOrTrait: PropTypes.string,
    strongestSnpRiskAllele: PropTypes.string,
  }),
  gwasList: PropTypes.arrayOf(
    PropTypes.shape({
      strongestRiskAllele: PropTypes.string,
      readableDate: PropTypes.string,
      pubMedRefs: PropTypes.arrayOf(PropTypes.any),
      oddsRatio: PropTypes.string,
      pValue: PropTypes.string,
      diseaseOrTrait: PropTypes.string,
      confidenceLow: PropTypes.string,
      confidenceHigh: PropTypes.string,
      confidenceComment: PropTypes.string,
      id: PropTypes.string,
    })
  ),

  openGwasModal: PropTypes.func.isRequired,
};

GWASContent.defaultProps = {
  labels: {},
  gwasList: [],
};

export default GWASContent;
